const { jQuery: $, themeSettings: config } = window;
import Theme from './modules/theme.class';
import Utils from "./modules/utils.class";
import SlickSlider from "./modules/slickslider.class";

// require("./lib/slick");
import Slick from "imports-loader?imports=default|jquery|$!./lib/slick";

const utils = new Utils();
const theme = new Theme(
    config,
    utils,
    new SlickSlider(utils)
);

$(() => theme.__onReady());
$(window).on('load', () => theme.__onLoad());
$(window).on('resize', () => theme.__onResize());

$(window).on('kpf:ready', (e, kpf) => theme.__postFilters(kpf));


window.Theme = theme;

Utils.log("Loading Theme...");